<template>
  <MainLayout hide-route-header>
    <Card class="max-w-lg mx-auto">
      <CardContent>
        <div id="calendly-embed" ref="calendlyEmbed" style="min-width: 320px; height: 700px" class="mb-12"></div>

        <div class="mt-4">
          <TButton @click="scheduleKickoffCall">
            <vue-feather type="check" class="w-4 h-4 mr-2" />
            Mark completed
          </TButton>
        </div>
      </CardContent>
    </Card>
  </MainLayout>
</template>

<script>
import MainLayout from '@/components/layouts/MainLayout/index.vue';
import { Card, CardContent } from '@/components/ui/card';
import TButton from '../../components/shared/TButton.vue';
import { hFetch } from '../../api/hFetch';
import { useCurrentUserStore } from '@/stores/currentUser.ts';

export default {
  components: {
    MainLayout,
    Card,
    CardContent,
    TButton,
  },
  setup() {
    const currentUserStore = useCurrentUserStore();
    return { currentUserStore };
  },
  data() {
    return {
      loadedCalendly: false,
    };
  },
  mounted() {
    setTimeout(() => {
      if (!this.loadedCalendly && this.$refs.calendlyEmbed) {
        console.log('we are loading the calendly widget');
        Calendly.initInlineWidget({
          url: 'https://calendly.com/d/y3y-r6z-668/humaniz-onboarding?hide_event_type_details=1&hide_gdpr_banner=1',
          parentElement: this.$refs.calendlyEmbed,
          prefill: {
            name: `${this.currentUserStore.currentUser.firstName} ${this.currentUserStore.currentUser.lastName}`,
            email: this.currentUserStore.currentUser.email,
          },
        });
        this.loadedCalendly = true;
      }
    }, 1000);
  },
  methods: {
    async scheduleKickoffCall() {
      const data = await hFetch({
        url: '/api/quickstart/scheduled_kickoff_calls',
        method: 'POST',
        payload: {
          scheduled_kickoff_call: true,
        },
      });

      if (data.success) {
        this.$router.push('/');
      }
    },
  },
};
</script>
